export default __webpack_public_path__ + "static/media/mobility_plan.5f3a7906.svg";